import React, {Component} from 'react';

class Footer extends Component {
  render() {
    const options = [
      { value: 'development', label: 'Development' },
      { value: 'production_dev', label: 'Web.dev.houselink.info' },
      { value: 'production_empty', label: 'Demo.dev.houselink.info' },
      { value: 'localhost', label: 'Localhost' },
    ];
    const api_mode = window.localStorage.getItem('admin_api_mode');
    const item = options.find(item => item.value === api_mode) || { value: '' , label: 'Demo.dev.houselink.info'};
    return (
      <footer className="app-footer">
        <span>API run as {item.label}</span>
        <span className="ml-auto"><a target="_blank" href="http://houselink.com.vn">Home website</a></span>
      </footer>
    )
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js